/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUploadDocument
 */
export interface BulkUploadDocument {
    /**
     * 
     * @type {string}
     * @memberof BulkUploadDocument
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BulkUploadDocument
     */
    s3_key: string;
}

/**
 * Check if a given object implements the BulkUploadDocument interface.
 */
export function instanceOfBulkUploadDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "s3_key" in value;

    return isInstance;
}

export function BulkUploadDocumentFromJSON(json: any): BulkUploadDocument {
    return BulkUploadDocumentFromJSONTyped(json, false);
}

export function BulkUploadDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUploadDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        's3_key': json['s3_key'],
    };
}

export function BulkUploadDocumentToJSON(value?: BulkUploadDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        's3_key': value.s3_key,
    };
}

